<form [formGroup]="form">
        <app-dropdown-autocomplete formControlName="line"
                                   labelAlign="left"
                                   displayField="name"
                                   valueField="id"
                                   [formControl]="form.controls.line"
                                   [showErrors]="showValidations"
                                   [items]="lines"
                                   [appendTo]="'body'"
                                   [label]="'admin.tools.form.labels.line.label' | translate"
                                   [emptyText]="'admin.tools.form.labels.line.placeholder' | translate"
                                   [resetSelectionOnItemChange]="false"
                                   [disabled]="disabled">
        </app-dropdown-autocomplete>
</form>
